// @ts-nocheck
import React, { createRef } from "react";
import { Tooltip, Dropdown, Menu, Popover } from "antd";
import lodash from "lodash";
import BaseShareOnModal from "./baseShareOnModal";
import SectionEditIcon from "../../../base/basicComponents/sectionEditIcon";
import NormalToolTip from "../../../base/basicComponents/toolTip";
import ShareTaskTable from "./shareTaskTable";
import ShareTaskModal from "./shareTaskModal";
import NormalModal from "../../../base/basicComponents/modal";
import TaskInformation from "../taskInfoSections";
import shareTaskService from "../../../service/shareTask";
import ProcedureDetailService from "../../../service/procedureFile/ProcedureDetailService";
import { shareTaskMassage } from "../../publicDictionaryValues";
import noSharedTaskImg from "../../../assets/image/noSharedTask.png";
import redTipIcon from "../../../assets/image/redTipIcon.png";
import styles from "./index.module.scss";
import "./share.scss";
import ChangeMainTaskModal from "./changeMainTaskModal";
import fullScreenIcon from "../../../assets/image/fullScreen.png";
import fullScreenHoverIcon from "../../../assets/image/fullScreenHover.png";
import miniScreenIcon from "../../../assets/image/miniScreen.png";
import miniScreenHoverIcon from "../../../assets/image/miniScreenHover.png";
import { getPendingAction } from "../../../store/actions/procedureDetailPageActions";
import { PendingActionTypes } from "../../../store/actions/constants";
import { checkLatestProcedureInfo } from "../../pages/procedureDetail/utils";

const changeMainTaskRef = createRef();

export default class ShareTask extends BaseShareOnModal {
  constructor(props: any) {
    super(props);
    this.state = {
      editCheckFail: false,
      editCheckMessage: "",
      sharingProcessStatus: 0,
      hasActiveShardTask: true,
      data: [],
      isEdit: false,
      editDropdownShow: false,
      isLocked: false,
      lockName: "",
      isEditToolTipOpen: false,
      isModalOpen: false,
      initModalTableData: [],
      modalTableData: [],
      accountSelectOption: [],
      accountSelectValue: null,
      taskTreePathOption: [],
      taskTreePathValue: null,
      isAddNewShareTaskShow: false,
      submitDisabled: true,
      taskInformationData: {},
      isTaskInfoModalOpen: false,
      reseanValue: "",
      hasDeleteTag: false,
      reasonInputStatus: "",
      isComfirmOpen: false,
      confirmModalText: "",
      handleComfirm: () => {
        //this is a empty function
      },
      isExpendData: false,
      iconSrc: fullScreenIcon,
      selectTaskDisable: false,
    };
    // @ts-ignore
    this.selectTaskDisable = false;
  }

  ReleaseLock = () => {
    const para = {
      procedureId: this.props.procedureId,
      procedureSectionType: "ShareTask",
      setLock: false,
    };
    ProcedureDetailService.setSectionLock(
      para,
      () => {
        //this.is an empty function
      },
      (response: any) => {
        console.log(response.message);
      }
    );
  };

  compareArrays = (arr1: any, arr2: any) => {
    if (arr1.length !== arr2.length) {
      return false;
    }

    for (let i = 0; i < arr1.length; i++) {
      const obj1 = arr1[i];
      const obj2 = arr2[i];

      for (let key in obj1) {
        if (key !== "errorMessage" && key !== "hasError") {
          if (obj1[key] !== obj2[key]) {
            return false;
          }
        }
      }
    }

    return true;
  };

  CheckSubmitDisable = (currentData: any) => {
    const modalTableData = JSON.parse(JSON.stringify(currentData));
    const initModalTableData = JSON.parse(JSON.stringify(this.state.initModalTableData));
    const eq = this.compareArrays(modalTableData, initModalTableData);
    if (eq) {
      this.setState({
        submitDisabled: true,
      });
    } else {
      this.setState({
        submitDisabled: false,
      });
    }
  };

  checkDeleteTag = (currentData: any) => {
    const deleteTagDataIndex = currentData.findIndex(
      (x: any) => x.isDeleted !== undefined && x.isDeleted === true
    );
    if (deleteTagDataIndex > -1) {
      this.setState({
        hasDeleteTag: true,
      });
    } else {
      this.setState({
        hasDeleteTag: false,
        reasonInputStatus: "",
      });
    }
  };

  ModalTableOnDelete = (record: any) => {
    let data = JSON.parse(JSON.stringify(this.state.modalTableData));
    const index = data.findIndex((x: any) => x.taskId === record.taskId);
    if (record.isNew) {
      data.splice(index, 1);
      this.setState({
        modalTableData: data,
      });
    } else {
      data[index] = { ...data[index], isDeleted: true };
      this.setState({
        modalTableData: data,
        hasDeleteTag: true,
      });
    }

    this.CheckSubmitDisable(data);
  };

  ModalTableOnRevoke = (record: any) => {
    let data = JSON.parse(JSON.stringify(this.state.modalTableData));
    const index = data.findIndex((x: any) => x.taskId === record.taskId);
    delete data[index]["isDeleted"];
    this.setState({
      modalTableData: data,
    });
    this.CheckSubmitDisable(data);
    this.checkDeleteTag(data);
  };

  ShowAddNewShareTask = () => {
    this.setState({
      isAddNewShareTaskShow: true,
    });
  };

  ModalCheckSubmitOnSuccess = (result: any) => {
    this.props.hideLoading();
    let currentData = JSON.parse(JSON.stringify(this.state.modalTableData));
    if (!result.result) {
      const errorMsg =
        "There are some tasks that do not meet the conditions for adding to or removing from the sharing relationship. Please check the specific reasons in the task list.";
      this._alertError(errorMsg, 6);
      const responseData = result.resultList;
      for (let index = 0; index < currentData.length; index++) {
        const responseIndex = responseData.findIndex(
          (x: any) => x.taskId === currentData[index].taskId && !x.checkResult
        );
        if (responseIndex > -1) {
          currentData[index] = {
            ...currentData[index],
            hasError: true,
            // @ts-ignore
            errorMessage: shareTaskMassage[responseData[responseIndex].msgCode],
          };
        } else {
          currentData[index] = {
            ...currentData[index],
            hasError: false,
            errorMessage: "",
          };
        }
      }
      this.setState({
        modalTableData: currentData,
      });
    } else {
      const data = currentData.map((item: any) => {
        if (item.hasError === true) {
          return {
            ...item,
            hasError: false,
            errorMessage: "",
          };
        }

        return item;
      });
      this.setState({
        modalTableData: data,
        isComfirmOpen: true,
        confirmModalText: "Are you sure to submit?",
        handleComfirm: this.HandleComfirm,
      });
    }
  };

  refreshPage = () => {
    const para = {
      procedureId: this.props.procedureId,
      procedureSectionType: "ShareTask",
      setLock: false,
    };
    ProcedureDetailService.setSectionLock(
      para,
      () => {
        window.location.reload();
      },
      (response: any) => {
        //empty function
      }
    );
  };

  ModalSubmitOnSuccess = () => {
    this.props.hideLoading();
    this._alertSuccess("Submit Successful");
    this.refreshPage();
  };

  HandleComfirm = () => {
    this.props.showLoading();
    this.setState({
      isComfirmOpen: false,
      isModalOpen: false,
    });
    const currentData = JSON.parse(JSON.stringify(this.state.modalTableData));
    const para = {
      tasks: currentData,
      reason: this.state.reseanValue,
      procedureId: this.props.procedureId,
      proceduretaskId: this.props.procedureTaskId,
    };
    shareTaskService.submitForApproval(para, this.ModalSubmitOnSuccess, this.ModalOnSubmitOnError);
  };

  HandleComfirmCancel = () => {
    this.setState({
      isComfirmOpen: false,
    });
  };

  ModalOnSubmitOnError = () => {
    this.props.hideLoading();
    this._alertError("Submit Failed");
    this.setState({
      isComfirmOpen: false,
    });
  };

  ModalCheckSubmitOnError = () => {
    this.props.hideLoading();
    this._alertError("Check Failed");
  };

  stopLoading = () => {
    this.props.hideLoading();
    Array.from(document.getElementsByClassName("ant-modal-body")).forEach((element) => {
      // @ts-ignore
      element.style.pointerEvents = "auto";
    });
  };

  ModalOnSubmit = async () => {
    this.props.showLoading();
    const shouldContinue = await checkLatestProcedureInfo({
      actionType: PendingActionTypes.SharedTasksManageSharedTask,
      procedureTaskId: this.props.procedureTaskId,
      callbackType: "ONLY_MESSAGE",
    });
    if (!shouldContinue) {
      this.props.hideLoading();
      return;
    }

    let currentData = JSON.parse(JSON.stringify(this.state.modalTableData));
    if (this.state.hasDeleteTag) {
      if (this.state.reseanValue.trim() === "") {
        this.setState({
          reasonInputStatus: "error",
        });
        this.props.hideLoading();
        return;
      }
    }
    const para = {
      procedureId: this.props.procedureId,
      taskList: currentData,
    };
    shareTaskService.checkSubmit(
      para,
      this.ModalCheckSubmitOnSuccess,
      this.ModalCheckSubmitOnError
    );
  };

  HandleCancle = () => {
    this.setState({
      isComfirmOpen: false,
      isModalOpen: false,
      modalTableData: [],
      accountSelectValue: this.state.accountSelectOption[0].value,
      taskTreePathValue: null,
      isAddNewShareTaskShow: false,
      submitDisabled: true,
      hasDeleteTag: false,
      reseanValue: "",
      reasonInputStatus: "",
    });
    this.ReleaseLock();
    this.props.setActionType(null);
  };

  ModalOnCancle = () => {
    this.setState({
      isComfirmOpen: true,
      confirmModalText: "Are you sure to quit without saving?",
      handleComfirm: this.HandleCancle,
    });
  };

  AddTaskOnClickOnSuccess = (result: any) => {
    const newLine = { ...result, isNew: true, isMainTask: false };
    const currentModalTableData = JSON.parse(JSON.stringify(this.state.modalTableData));
    const duplicateLineIndex = currentModalTableData.findIndex(
      (x: any) => x.taskId === newLine.taskId
    );
    if (duplicateLineIndex > -1) {
      this._alertError("This Task already exists.");
      this.setState({
        taskTreePathValue: null,
      });
      return;
    }
    currentModalTableData.push(newLine);
    this.setState({
      modalTableData: currentModalTableData,
      taskTreePathValue: null,
    });
    this.CheckSubmitDisable(currentModalTableData);
  };

  AddTaskOnClickOnError = (result: any) => {
    this.props.hideLoading();
    console.log("Add Task Failed");
  };

  AddTaskOnClick = () => {
    this._showLoading();
    shareTaskService.getRowData(
      this.state.taskTreePathValue,
      this.AddTaskOnClickOnSuccess,
      this.AddTaskOnClickOnError
    );
  };

  GetModalTableDataSuccess = (result: any) => {
    this._setLock(this.props.procedureId, "ShareTask", true);
    this.props.setActionType("ShareTask");
    this.props.hideLoading();
    this.setState({
      isModalOpen: true,
      modalTableData: result,
      initModalTableData: result,
    });
  };

  GetModalTableDataFail = (result: any) => {
    console.log(result);
  };

  checkManageShareTaskWhetherLock = (isLock: any, lockUser: any) => {
    if (isLock) {
      this.props.hideLoading();
      this.setState({
        isLocked: true,
        lockName: lockUser,
        isEditToolTipOpen: true,
      });
    } else {
      this.setState({
        isLocked: false,
        isEditToolTipOpen: false,
      });
      const para = {
        procedureId: this.props.procedureId,
        isCreate: false,
      };
      shareTaskService.getMainTaskInfo(
        para,
        this.GetModalTableDataSuccess,
        this.GetModalTableDataFail
      );
    }
  };

  ManageSharedTasksOnClick = async () => {
    await checkLatestProcedureInfo({
      actionType: PendingActionTypes.SharedTasksManageSharedTask,
      procedureTaskId: this.props.procedureTaskId,
    });

    // @ts-ignore
    this.actionType = "ShareTask";
    const para = {
      procedureId: this.props.procedureId,
      // @ts-ignore
      procedureSectionType: this.actionType,
      timeOutMins: 20,
    };
    ProcedureDetailService.checkSectionLock(
      para,
      (response: any) =>
        this.checkManageShareTaskWhetherLock(response.data.isLocked, response.data.lockUser),
      (response: any) => {
        this.props.hideLoading();
        console.log(response.message);
      }
    );
  };

  checkChangeMainTaskWhetherLock = (isLock: any, lockUser: any) => {
    if (isLock) {
      this.props.hideLoading();
      this.setState({
        isLocked: true,
        lockName: lockUser,
        isEditToolTipOpen: true,
      });
    } else {
      this.setState({
        isLocked: false,
        isEditToolTipOpen: false,
      });
      // @ts-ignore
      changeMainTaskRef.current.ShowModal();
    }
  };

  ManageChangeMainTaskOnClick = async () => {
    await checkLatestProcedureInfo({
      actionType: PendingActionTypes.SharedTasksChangeMainTask,
      procedureTaskId: this.props.procedureTaskId,
    });

    // @ts-ignore
    this.actionType = "ShareTask";
    const para = {
      procedureId: this.props.procedureId,
      // @ts-ignore
      procedureSectionType: this.actionType,
      timeOutMins: 20,
    };
    ProcedureDetailService.checkSectionLock(
      para,
      (response: any) =>
        this.checkChangeMainTaskWhetherLock(response.data.isLocked, response.data.lockUser),
      (response: any) => {
        this.props.hideLoading();
        console.log(response.message);
      }
    );
  };

  GetCheckEditSharingStatusOnSuccess = (result: any) => {
    if (result === 4) {
      this.ReleaseLock();
      this.props.hideLoading();
      this.setState({
        isLocked: false,
        isEditToolTipOpen: false,
        editDropdownShow: true,
        isEdit: true,
      });
    } else {
      this.setState({
        isLocked: false,
        isEditToolTipOpen: false,
      });
      const para = {
        procedureId: this.props.procedureId,
        isCreate: true,
      };
      shareTaskService.getMainTaskInfo(
        para,
        this.GetModalTableDataSuccess,
        this.GetModalTableDataFail
      );
    }
    const accountPara = {
      procedureTaskId: this.props.procedureTaskId,
      procedureStepId: null,
    };
    shareTaskService.getAccountDDL(
      accountPara,
      this.GetAccountDDLOnSuccess,
      this.GetAccountDDLOnError
    );
  };

  GetCheckEditSharingStatusOnError = () => {
    this.props.hideLoading();
  };

  shareTaskUnLock = () => {
    const para = {
      procedureId: this.props.procedureId,
      proceduretaskId: this.props.procedureTaskId,
    };
    shareTaskService.getSharingProcessStatus(
      para,
      this.GetCheckEditSharingStatusOnSuccess,
      this.GetCheckEditSharingStatusOnError
    );
  };

  checkShareTaskWhetherLock = (isLock: any, lockUser: any) => {
    if (isLock) {
      this.props.hideLoading();
      this.setState({
        isLocked: true,
        lockName: lockUser,
        isEditToolTipOpen: true,
      });
    } else {
      this.shareTaskUnLock();
    }
  };

  CheckLock = () => {
    // @ts-ignore
    this.actionType = "ShareTask";
    const para = {
      procedureId: this.props.procedureId,
      // @ts-ignore
      procedureSectionType: this.actionType,
      timeOutMins: 20,
    };
    ProcedureDetailService.checkSectionLock(
      para,
      (response: any) =>
        this.checkShareTaskWhetherLock(response.data.isLocked, response.data.lockUser),
      (response: any) => {
        this.props.hideLoading();
        console.log(response.message);
      }
    );
  };

  CheckEditOnSuccess = (result: any) => {
    this.props.hideLoading();
    if (result.result === true) {
      this.CheckLock();
    } else {
      this.setState({
        editCheckFail: true,
        // @ts-ignore
        editCheckMessage: shareTaskMassage[result.messageCode],
      });
    }
  };

  CheckEditOnError = (result: any) => {
    this.props.hideLoading();
    console.log(result);
  };

  HandleEditClick = async () => {
    this.props.showLoading();
    await checkLatestProcedureInfo({
      actionType: PendingActionTypes.SharedTasksEdit,
      procedureTaskId: this.props.procedureTaskId,
    });

    const para = {
      procedureId: this.props.procedureId,
      procedureTaskId: this.props.procedureTaskId,
    };
    shareTaskService.checkEdit(para, this.CheckEditOnSuccess, this.CheckEditOnError);
  };

  HandleEditOnBlur = () => {
    if (!this.props.isShowShareTaskEdit) return;
    setTimeout(() => {
      this.setState({
        editCheckFail: false,
        isEditToolTipOpen: false,
        editDropdownShow: false,
      });
    }, 300);
  };

  GetActiveShareTaskListOnSuccess = (result: any) => {
    this.setState({
      data: result,
      isExpendData: result.length === 0,
    });
    this.handleDefaultExpendIcon();
  };

  GetActiveShareTaskListOnError = (result: any) => {
    console.log(result);
  };

  NoActiveShardTask = () => {
    this.setState({
      hasActiveShardTask: false,
    });
  };

  SetIsEdit = () => {
    this.setState({
      isEdit: true,
    });
  };

  GetSharingProcessStatusOnSuccess = (result: any) => {
    this.setState({
      sharingProcessStatus: result,
    });
    if (result === 1 || result === 2) {
      this.setState({
        hasActiveShardTask: false,
      });
    } else {
      const para = {
        procedureId: this.props.procedureId,
        procedureTaskId: this.props.procedureTaskId,
      };
      shareTaskService.getActiveShareTaskList(
        para,
        this.GetActiveShareTaskListOnSuccess,
        this.GetActiveShareTaskListOnError
      );
    }

    if (result === 1) {
      this.NoActiveShardTask();
    }

    if (result === 2) {
      this.NoActiveShardTask();
    }

    if (result === 4) {
      this.SetIsEdit();
    }
  };

  GetSharingProcessStatusOnError = (result: any) => {
    console.log(result);
  };

  GetSharingProcessStatus = () => {
    const para = {
      procedureId: this.props.procedureId,
      proceduretaskId: this.props.procedureTaskId,
    };
    shareTaskService.getSharingProcessStatus(
      para,
      this.GetSharingProcessStatusOnSuccess,
      this.GetSharingProcessStatusOnError
    );
  };

  componentDidMount() {
    this.GetSharingProcessStatus();
    document.addEventListener("click", this.HandleEditOnBlur);
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.HandleEditOnBlur);
  }

  componentDidUpdate(prevProps: any, prevState: any) {
    if (
      this.state.modalTableData.length > 4 &&
      this.state.modalTableData.length > prevState.modalTableData.length
    ) {
      const tbody = document.querySelector(".modal-shared-task-table .ant-table-body");
      if (tbody) {
        tbody.scrollTop = tbody.scrollHeight;
      }
    }

    const pendingAction = getPendingAction();
    const pendingActionMap = {
      [PendingActionTypes.SharedTasksChangeMainTask]: () => {
        const accountPara = {
          procedureTaskId: this.props.procedureTaskId,
          procedureStepId: null,
        };
        shareTaskService.getAccountDDL(
          accountPara,
          this.GetAccountDDLOnSuccess,
          this.GetAccountDDLOnError
        );
        this.ManageChangeMainTaskOnClick();
      },

      [PendingActionTypes.SharedTasksEdit]: () => {
        if (this.props.isShowShareTaskEdit) {
          this.HandleEditClick();
        }
      },
      [PendingActionTypes.SharedTasksManageSharedTask]: () => {
        const accountPara = {
          procedureTaskId: this.props.procedureTaskId,
          procedureStepId: null,
        };
        shareTaskService.getAccountDDL(
          accountPara,
          this.GetAccountDDLOnSuccess,
          this.GetAccountDDLOnError
        );
        this.ManageSharedTasksOnClick();
      },
    };
    if (pendingActionMap[pendingAction]) {
      pendingActionMap[pendingAction]();
    }
  }

  handleEditCheckMessage = (
    editCheckFail: any,
    editCheckMessage: any,
    isLocked: any,
    lockName: any
  ) => {
    if (editCheckFail) {
      return editCheckMessage;
    } else if (isLocked) {
      return `${lockName} is editing this section.`;
    }
    return editCheckMessage;
  };

  openConfirmModal = (handleComfirm: any, message: any) => {
    this.setState({
      isComfirmOpen: true,
      confirmModalText: message,
      handleComfirm: handleComfirm,
    });
  };

  handleDefaultExpendIcon = () => {
    this.setState({
      iconSrc: this.state.isExpendData ? miniScreenIcon : fullScreenIcon,
    });
  };

  handleHoverExpendIcon = () => {
    this.setState({
      iconSrc: this.state.isExpendData ? miniScreenHoverIcon : fullScreenHoverIcon,
    });
  };

  handleExpendFlag = () => {
    const flag = !this.state.isExpendData;
    this.setState({ isExpendData: flag });
  };

  sharedTaskTableListControlIcon = () => {
    const { isExpendData, iconSrc } = this.state;
    return (
      <p className="listControlIcon">
        <img
          src={iconSrc}
          alt={isExpendData ? "pick up" : "show all"}
          onMouseEnter={this.handleHoverExpendIcon}
          onMouseLeave={this.handleDefaultExpendIcon}
          onClick={this.handleExpendFlag}
          data-testid="share-task-list-expand-icon"
        />
      </p>
    );
  };

  // @ts-ignore
  render() {
    const {
      isEditToolTipOpen,
      editCheckFail,
      editCheckMessage,
      sharingProcessStatus,
      hasActiveShardTask,
      data,
      isEdit,
      editDropdownShow,
      isLocked,
      lockName,
      isModalOpen,
      modalTableData,
      accountSelectOption,
      accountSelectValue,
      taskTreePathOption,
      taskTreePathValue,
      isAddNewShareTaskShow,
      submitDisabled,
      taskInformationData,
      isTaskInfoModalOpen,
      reseanValue,
      hasDeleteTag,
      reasonInputStatus,
      isExpendData,
      selectTaskDisable,
    } = this.state;

    const column = [this.isMainTaskColumn, ...this.commonShareDataColumn, this.effectiveDateColumn];
    const modalTableColumn = [
      {
        title: "",
        dataIndex: "isMainTask",
        width: 120,
        render: (text: any, record: any) => (
          <div>
            {/* @ts-ignore */}
            <Popover
              content={
                <span className={`${styles.errorPopContent} fs-14`}>{record.errorMessage}</span>
              }
              placement="topLeft"
              title={null}
              trigger="click"
              getPopupContainer={(triggerNode) =>
                triggerNode.parentNode.parentNode.parentNode.parentNode
              }
              overlayClassName="shareTooltip"
            >
              <img
                src={redTipIcon}
                alt="error"
                className={record.hasError ? styles.redTipIconShow : styles.redTipIconHide}
              />
            </Popover>
            <span className={`${record.isMainTask ? styles.mainTaskText : styles.tableText} fs-14`}>
              {record.isMainTask ? "Main Task" : "Shared Task"}
            </span>
          </div>
        ),
      },
      {
        title: "Account",
        dataIndex: "account",
        ellipsis: {
          showTitle: false,
        },
        width: 100,
        render: (accountName: any, record: any) => (
          <Tooltip placement="bottomLeft" title={accountName} overlayClassName="shareTooltip">
            <span className={`${styles.tableText} fs-14`}>{accountName}</span>
          </Tooltip>
        ),
      },
      {
        title: "Task Tree Path",
        dataIndex: "taskTreePath",
        ellipsis: {
          showTitle: false,
        },
        width: 140,
        render: (taskTreePath: any) => (
          <Tooltip placement="bottomLeft" title={taskTreePath} overlayClassName="shareTooltip">
            <span className={`${styles.tableText} fs-14`}>{taskTreePath}</span>
          </Tooltip>
        ),
      },
      {
        title: "Task Label Name",
        dataIndex: "taskLabelName",
        ellipsis: {
          showTitle: false,
        },
        width: 160,
        render: (taskLableName: any) => (
          <Tooltip placement="bottomLeft" title={taskLableName} overlayClassName="shareTooltip">
            <span className={`${styles.tableText} fs-14`}>{taskLableName}</span>
          </Tooltip>
        ),
      },
      {
        title: "Task ID",
        dataIndex: "taskId",
        ellipsis: {
          showTitle: false,
        },
        width: 90,
        render: (taskId: any) => (
          <Tooltip placement="bottomLeft" title={taskId} overlayClassName="shareTooltip">
            <span className={`${styles.tableText} fs-14`}>{taskId}</span>
          </Tooltip>
        ),
      },
      {
        title: "Primary Procedure Owner",
        dataIndex: "ppo",
        ellipsis: {
          showTitle: false,
        },
        width: 200,
        render: (ppo: any) => (
          <Tooltip placement="bottomLeft" title={ppo} overlayClassName="shareTooltip">
            <span className={`${styles.tableText} fs-14`}>{ppo}</span>
          </Tooltip>
        ),
      },
      {
        title: "Procedure Owner",
        dataIndex: "po",
        ellipsis: {
          showTitle: false,
        },
        width: 150,
        render: (po: any) => (
          <Tooltip placement="bottomLeft" title={po} overlayClassName="shareTooltip">
            <span className={`${styles.tableText} fs-14`}>{po}</span>
          </Tooltip>
        ),
      },
      {
        title: "Procedure Saved In",
        dataIndex: "procedureSavedIn",
        ellipsis: {
          showTitle: false,
        },
        width: 160,
        render: (procedureSavedIn: any) => (
          <Tooltip placement="bottomLeft" title={procedureSavedIn} overlayClassName="shareTooltip">
            <span className={`${styles.tableText} fs-14`}>{procedureSavedIn}</span>
          </Tooltip>
        ),
      },
      {
        title: "Client Server Path",
        dataIndex: "clientServerPath",
        ellipsis: {
          showTitle: false,
        },
        width: 180,
        render: (clientServerPath: any) => (
          <Tooltip
            placement="bottomLeft"
            title={clientServerPath}
            overlayClassName={styles.clientServerPathToolTip}
          >
            <span className={`${styles.tableText} fs-14`}>{clientServerPath}</span>
          </Tooltip>
        ),
      },
      this.tagColumn(100),
      {
        title: "Action",
        dataIndex: "action",
        align: "center",
        width: 110,
        render: (text: any, record: any) => {
          if (record.isMainTask) {
            return;
          }

          if (record.isDeleted) {
            return (
              <div
                className={`${styles.modalTableActionIcon} ${styles.sectionRevokeIcon}`}
                onClick={() => this.ModalTableOnRevoke(record)}
                data-testid={`share-task-revoke-icon-${record.taskId}`}
              />
            );
          }

          return (
            <div
              className={`${styles.modalTableActionIcon} ${styles.sectionDeleteIcon}`}
              onClick={() => this.ModalTableOnDelete(record)}
              data-testid={`share-task-delete-icon-${record.taskId}`}
            />
          );
        },
      },
    ];
    const editDropdownMenu = (
      <Menu>
        <Menu.Item onClick={this.ManageChangeMainTaskOnClick} key="changeMainTask">
          Change Main Task
        </Menu.Item>
        <Menu.Item onClick={this.ManageSharedTasksOnClick} key="manageSharedTasks">
          Manage Shared Tasks
        </Menu.Item>
      </Menu>
    );
    return (
      <div className={styles.shareInformation}>
        <div className={styles.shareInfoTop}>
          <div>
            <span className={`${styles.shareTitle} fs-18`} data-scroll-target-id="Shared Tasks">
              Shared Tasks
            </span>
            <span className={`${styles.sharingProcessStatus} fs-14`}>
              {sharingProcessStatus === 2 || sharingProcessStatus === 3
                ? "This section is pending approval."
                : ""}
            </span>
          </div>

          {this.props.isShowShareTaskEdit && (
            <Dropdown
              overlay={editDropdownMenu}
              trigger={["click"]}
              visible={isEdit && editDropdownShow}
              arrow={true}
              placement="bottomRight"
              overlayClassName={`antDropDown ${styles.editDropdownMenu}`}
              getPopupContainer={(triggerNode) => triggerNode}
              onVisibleChange={(show) =>
                this.setState({
                  editDropdownShow: show,
                })
              }
            >
              <NormalToolTip
                element={
                  <SectionEditIcon
                    handleEditClick={lodash.debounce(this.HandleEditClick, 500)}
                    onBlur={this.HandleEditOnBlur}
                    showDownArrow={isEdit}
                    className={styles.sectionEdit}
                    testid="share-task-section-edit-btn"
                  />
                }
                title={this.handleEditCheckMessage(
                  editCheckFail,
                  editCheckMessage,
                  isLocked,
                  lockName
                )}
                trigger="click"
                open={isEditToolTipOpen || editCheckFail}
                placement="left"
                color="#3E6CB5"
              />
            </Dropdown>
          )}
        </div>
        <div className={styles.sharedTaskArea}>
          {!hasActiveShardTask && (
            <div className={styles.noSharedTaskDiv}>
              <img alt="no shared task" src={noSharedTaskImg} className={styles.noSharedTaskImg} />
              <p className={`${styles.noSharedTaskMassage} fs-16`}>No Shared Task Yet</p>
            </div>
          )}
          {hasActiveShardTask && (
            <>
              {data.length > 4 && (
                <div className="sharedTaskTableTop">{this.sharedTaskTableListControlIcon()}</div>
              )}
              <ShareTaskTable
                data={data}
                columns={column}
                scroll={{
                  y: isExpendData || data.length <= 4 ? null : "13.75rem",
                }}
              />
              <p className="fileNumTip" style={{ color: "#333" }}>
                <span className="fileNum">{data.length}</span> {this.setFileText(data.length)} in
                total
              </p>
            </>
          )}
        </div>
        <ShareTaskModal
          isModalOpen={isModalOpen}
          tableColumn={modalTableColumn}
          tableData={modalTableData}
          onSubmit={this.ModalOnSubmit}
          onCancel={this.ModalOnCancle}
          accountSelectOption={accountSelectOption}
          accountSelectValue={accountSelectValue}
          accountSelectOnChange={this.AccountSelectOnChange}
          taskTreePathOption={taskTreePathOption}
          taskTreePathValue={taskTreePathValue}
          taskTreePathOnSearch={this.TaskTreePathOnSearch}
          taskTreePathOnChange={this.TaskTreePathOnChange}
          addTaskOnClick={this.AddTaskOnClick}
          clearAddTaskOnClick={this.ClearAddTaskOnClick}
          isAddNewShareTaskShow={isAddNewShareTaskShow}
          showAddNewShareTask={this.ShowAddNewShareTask}
          submitDisabled={submitDisabled}
          reseanValue={reseanValue}
          reseanOnChange={(e: any) => this.ReseanOnChange(e.target)}
          hasDeleteTag={hasDeleteTag}
          reasonInputStatus={reasonInputStatus}
          zIndex={990}
          refreshPage={this.refreshPage}
          selectTaskDisable={selectTaskDisable}
        />
        {/* @ts-ignore */}
        <ChangeMainTaskModal
          ref={changeMainTaskRef}
          releaseLock={this.ReleaseLock}
          procedureTaskId={this.props.procedureTaskId}
          procedureId={this.props.procedureId}
          openConfirmModal={this.openConfirmModal}
          cancelConfilmModal={this.HandleComfirmCancel}
          refreshPage={this.refreshPage}
          zIndex={990}
          setActionType={this.props.setActionType}
          showLoading={this.props.showLoading}
          hideLoading={this.props.hideLoading}
        />
        <NormalModal
          testid="share-task-info-modal"
          centered
          footer={null}
          title="Task Information"
          isModalOpen={isTaskInfoModalOpen}
          handleCancel={this.HandleTaskInfoModalClose}
          width="93rem"
          childContent={<TaskInformation data={taskInformationData} isInModal={true} />}
          zIndex={990}
          className="taskInfoModal"
          closable={true}
        />
        <NormalModal
          testid="share-task-confirm-modal"
          okText="Confirm"
          cancelText="Cancel"
          childContent={<p className="fs-16">{this.state.confirmModalText}</p>}
          isModalOpen={this.state.isComfirmOpen}
          handleOk={this.state.handleComfirm}
          handleCancel={this.HandleComfirmCancel}
          okButtonTestid="share-task-confirm-modal-ok-btn"
          cancelButtonTestid="share-task-confirm-modal-cancel-btn"
        />
      </div>
    );
  }
}
